/**
 * N из M (F7 готовка, G1 двор, G5 стол, G9 чемодан, G12 бюджет, G11
 * урожай): кнопки-варианты, выбранные — `.active`; когда выбрано `max`,
 * остальные выключены, снять выбор можно. `grid` — сетка 3 колонки
 * (двор, поле), иначе столбик с пометками справа. Порядок выбора
 * сохраняется (готовка: первый — главный).
 */
import { t } from '@life/i18n';

export interface PickItem {
  text: string;
  note?: string;
  disabled?: boolean;
}

export interface PickProps {
  label: string;
  items: PickItem[];
  max: number;
  value: number[];
  onChange: (value: number[]) => void;
  grid?: boolean;
  /** Не показывать счётчик «выбрано n из max». */
  quiet?: boolean;
}

export function Pick({ label, items, max, value, onChange, grid = false, quiet = false }: PickProps) {
  const full = value.length >= max;
  const toggle = (i: number) => {
    if (value.includes(i)) onChange(value.filter((v) => v !== i));
    else if (!full) onChange([...value, i]);
  };

  return (
    <div class="pick-wrap">
      {!quiet && (
        <p class="hint mono" aria-live="polite">
          {t('ui.minigame.pick.count', { n: value.length, max })}
        </p>
      )}
      <div class={grid ? 'pick grid' : 'pick picks column'} role="group" aria-label={label}>
        {items.map((item, i) => {
          const active = value.includes(i);
          return (
            <button
              type="button"
              key={i}
              class={`btn${active ? ' active' : ''}`}
              aria-pressed={active}
              disabled={item.disabled === true || (full && !active)}
              onClick={() => toggle(i)}
            >
              <span>{item.text}</span>
              {item.note && <span class="note">{item.note}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
